import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'bootstrap/js/transition';
import 'bootstrap/js/carousel';

import QuestionLogCollection from 'screener/collections/question_log';
import QuestionLog from 'screener/models/question_log';
import CheckboxView from 'core/views/checkbox';


/* This view is used to handle screener answers. */

export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    var self = this;

    this.modal = options.modal;
    this.question_el = options.question_el;
    // The button for moving on. Could be a "next" carousel control, or
    // it could be the "Done" button at the end of the screener.
    this.submit_button = $('button, a.carousel-control', this.el);

    this.question = options.question;
    this.checkboxQuestion = this.question.get('question_type').indexOf('checkbox') > -1;
    this.screenerSetItem = options.screenerSetItem;
    this.answer = null;

    // Create the collection with an empty question log
    this.question_log = new QuestionLog({
      question: this.question.get('resource_uri'),
      screener_set_item: this.screenerSetItem.get('resource_uri')
    }, { question: this.question });
    this.collection = new QuestionLogCollection(this.question_log);

    // Prevent default for carousel buttons
    this.submit_button.filter('a.carousel-control').click(function (e) {
      if (self.submit_button.is('.disabled')) {
        // Prevent carousel action if the button is disabled
        e.stopPropagation();
      }
      e.preventDefault();
    });

    // Enable checkboxes/radio buttons
    _.each($('a.check', this.el), function (checkboxEl) {
      var checkboxView = $(checkboxEl).data('checkbox_view');
      if (!checkboxView) {
        checkboxView = new CheckboxView({ el: checkboxEl });
      }
      checkboxView.on(
        this.checkboxQuestion ? 'checked unchecked' : 'checked',
        this.updateCheckboxAnswer
      );
    }, this);

    // Enable dropdown question types
    if (this.question.get('question_type') == 'dropdown') {
      // Enable saving dropdown questions
      _.each($('.form-dropdown', this.el), function (dropdown) {
        $(dropdown).data('dropdown-view').on('selected', this.update_dropdown_answer);
      }, this);
    }

    // Enable text question types
    if (_.contains([ 'short-text', 'long-text', 'number' ], this.question.get('question_type'))) {
      var text_elements = $('input, textarea', this.el);
      // Enable saving textareas and text inputs
      text_elements.on('blur', this.handle_text_blur);
    }
  },

  enable_submit: function () {
    this.submit_button.removeClass('disabled');

    // If a branching answer was selected, adjust the carousel button
    // to skip to the requested question
    var branch_to = this.answer && this.answer.data('branch_to');
    if (branch_to && this.submit_button.is('a.carousel-control')) {
      var items = $('div.item', this.modal);
      var question_data = '[data-question="' + branch_to + '"]';
      var question = items.filter(question_data);
      if (question.length) {
        // Rig the "next" button to slide to the correct question
        var slide_to = items.index(question);
        this.submit_button
          .removeAttr('data-slide')
          .attr('data-slide-to', slide_to);
      }
    }
  },

  disable_submit: function () {
    this.submit_button
      .addClass('disabled')
      .removeAttr('data-slide-to')
      .attr('data-slide', 'next');
  },

  isValid: function () {
    return this.collection.reduce(function (memo, model) {
      return memo && model.isValid();
    }, true);
  },

  handle_text_blur: function (text_el) {
    // text_el may be a blur event, or the element itself
    if (text_el.target) {
      text_el = text_el.target;
    }
    var valid = text_el.checkValidity();
    var $text_el = $(text_el);
    var new_value = $text_el.val();
    if (valid) {
      $text_el.parent().removeClass('has-error');
      $text_el.siblings('.text-danger').html('');
    } else {
      $text_el.parent().addClass('has-error');
      // Set the question log value to blank so that it is not considered answered
      new_value = '';
      $text_el.siblings('.text-danger').html(text_el.validationMessage);
    }
    // Alter the question log with the new value
    this.question_log.set('value', new_value);
    // Trigger the appropriate event
    this.trigger(!new_value || new_value === '' || !valid ? 'unanswered' : 'answered');
  },

  update_dropdown_answer: function (value) {
    // Alter the question log with the new value
    this.question_log.set('value', value);
    this.trigger(!value || value === '' ? 'unanswered' : 'answered');
  },

  get_question_logs: function () {
    if (this.checkboxQuestion) {
      // Mark all but the last one as ! last_answer
      this.collection.each(function (question_log, i) {
        if (i !== this.collection.length - 1) {
          question_log.set('last_answer', false);
        }
      }, this);
    }
    return this.collection.models;
  },

  updateCheckboxAnswer: function (checkboxView) {
    // debugger
    var answer = checkboxView.$el.parent('li.answer, li.answer-noquestion');
    if (checkboxView.checked()) {
      this.answer = answer;
      // Uncheck other answers first, if they are radios
      if (this.question.get('question_type').indexOf('checkbox') !== 0) {
        _.each($('.answer', this.$el).not(this.answer), function (other_answer) {
          $('a.check', other_answer).data('checkbox_view').uncheck();
        });
      }
      // For checkbox questions, add a new question log, otherwise
      // alter the existing log.
      var new_value = this.answer.data('value');
      if (this.checkboxQuestion) {
        this.collection.add(new QuestionLog({
          question: this.question.get('resource_uri'),
          screener_set_item: this.screenerSetItem.get('resource_uri'),
          value: new_value
        }, { question: this.question }));
        if (this.question_log) {
          this.question_log.destroy();
        }
      } else {
        this.question_log.set('value', new_value);
      }
      this.trigger('answered');
    } else {
      // For checkbox questions, remove the appropriate question log,
      // otherwise, unset the value on the question_log
      if (this.checkboxQuestion) {
        var answer_value = answer.data('value');
        var old_question_log = this.collection.findWhere({
          value: answer_value
        });
        if (old_question_log) {
          old_question_log.destroy();
        }
        // Add dummy answer back if necessary
        if (this.collection.length === 0) {
          this.question_log = new QuestionLog({
            question: this.question.get('resource_uri'),
            screener_set_item: this.screenerSetItem.get('resource_uri')
          }, { question: this.question });
        }
      } else {
        this.question_log.unset('value');
      }
      this.trigger('unanswered');
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/views/answer.js
// module id = 163
// module chunks = 0